import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@collaborate-health/uikit'

import { UserQualificationsDisplayType } from '../../constants'

import UserQualificationsGrid from '../UserQualificationsGrid'

export interface ContractUsersQualificationsDialogProps {
  open: boolean
  contractVersion: {
    Id: number
  }
  onClose: () => void
}

const ContractUsersQualificationsDialog: React.FC<ContractUsersQualificationsDialogProps> = ({
  open,
  contractVersion,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='lg'>
      <DialogTitle>Contract qualifications</DialogTitle>

      <DialogContent>
        <UserQualificationsGrid
          simpleView
          contractVersion={contractVersion}
          displayType={UserQualificationsDisplayType.Contract}
        />
      </DialogContent>

      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ContractUsersQualificationsDialog

